import { DashboardService } from "../../../dashboard.service";
import {
  Component,
  PACKAGE_ROOT_URL,
  OnInit,
  OnChanges,
  SimpleChanges,
} from "@angular/core";
import { BsModalService } from "ngx-bootstrap/modal";
import { BsModalRef } from "ngx-bootstrap/modal";
import { AccountantService } from "../accountant.service";
import { FormBuilder, FormGroup, FormControl, Validators, FormsModule } from "@angular/forms";
import { FormUtil } from "../../../../utils/formutils";
import { HotToastService } from "@ngneat/hot-toast";
import { AddClientModalService } from "./add-client-modal.service";
import { LocalStorageService } from "src/app/utils/localstorage.service";
import { ConversationsService } from "../../../conversations/conversations.service";

/* This is a component which we pass in modal*/
@Component({
    selector: "notification-settings-modal",
    templateUrl: "./notification-settings-modal.component.html",
    imports: [FormsModule]
})
export class NotificationSettingsModalComponent implements OnInit {
  public _conversation: any = { options: { is_email_enabled: null } };

  constructor(
    public bsModalRef: BsModalRef,
    public toastr: HotToastService,
    private localStorage: LocalStorageService,
    private dashboardService: DashboardService,
    private conversationsService: ConversationsService
  ) {}

  ngOnInit(): void {}

  saveNotificationSettings() {
    this.dashboardService.show_loading.next(true);
    this.conversationsService
      .save_notification_settings(
        this._conversation.id,
        this._conversation.options
      )
      .then(
        (res: any) => {
          this.dashboardService.show_loading.next(false);
          this.toastr.success(res.message);
          this.bsModalRef.hide();
        },
        (err: any) => {
          console.log(err);
          this.dashboardService.show_loading.next(false);
          this.toastr.error(err.error.message);
        }
      );
  }
}
